/**
 * Returns a url for logs in to sesame and redirects to the provided url.
 */
export function wrapUrlWithSesameLogin(url, sesameToken = localStorage.getItem('sesameToken')) {
  return `/sesame/login/?sesame=${sesameToken}&next=${encodeURIComponent(url)}`;
}
